import React, { createContext, useContext, useState, useEffect } from "react";

const PopupAssignmentContext = createContext();

export const PopupAssignmentProvider = ({ children }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [showAssignmentBar, setShowAssignmentBar] = useState(false);
  const [popupDismissed, setPopupDismissed] = useState(false);

  // Initialize state from sessionStorage on mount
  useEffect(() => {
    if (typeof window !== "undefined") {
      const popupDismissedSession = sessionStorage.getItem("oktoberfest-popup-dismissed");
      const assignmentDismissedSession = sessionStorage.getItem("oktoberfest-assignment-dismissed");
      const isOktoberfestPage = window.location.pathname === "/oktoberfest";
      
      if (popupDismissedSession === "true") {
        setPopupDismissed(true);
      }
      
      // If popup was dismissed but assignment bar wasn't, show the bar on non-Oktoberfest pages
      if (
        popupDismissedSession === "true" && 
        assignmentDismissedSession !== "true" && 
        !isOktoberfestPage
      ) {
        setShowAssignmentBar(true);
      }
    }
  }, []);

  const handlePopupClose = () => {
    setShowPopup(false);
    setPopupDismissed(true);
    
    // Mark popup as dismissed in session storage
    if (typeof window !== "undefined") {
      sessionStorage.setItem("oktoberfest-popup-dismissed", "true");
    }
    
    // Show assignment bar after popup is closed
    setTimeout(() => {
      setShowAssignmentBar(true);
    }, 500);
  };

  const handleAssignmentBarClose = () => {
    setShowAssignmentBar(false);
    
    // Mark assignment bar as dismissed in session storage
    if (typeof window !== "undefined") {
      sessionStorage.setItem("oktoberfest-assignment-dismissed", "true");
    }
  };

  const resetState = () => {
    setShowPopup(false);
    setShowAssignmentBar(false);
    setPopupDismissed(false);
    
    // Clear session storage
    if (typeof window !== "undefined") {
      sessionStorage.removeItem("oktoberfest-popup-dismissed");
      sessionStorage.removeItem("oktoberfest-assignment-dismissed");
    }
  };

  return (
    <PopupAssignmentContext.Provider
      value={{
        showPopup,
        setShowPopup,
        showAssignmentBar,
        setShowAssignmentBar,
        popupDismissed,
        setPopupDismissed,
        handlePopupClose,
        handleAssignmentBarClose,
        resetState,
      }}
    >
      {children}
    </PopupAssignmentContext.Provider>
  );
};

export const usePopupAssignment = () => {
  const context = useContext(PopupAssignmentContext);
  if (!context) {
    throw new Error(
      "usePopupAssignment must be used within a PopupAssignmentProvider"
    );
  }
  return context;
};

export default PopupAssignmentContext;
